const SEARCH_TOKEN_SPLIT_REGEX = /[\s,;|]+/;
const DIACRITICS_REGEX = /[\u0300-\u036f]/g;
const SEARCH_COLLATOR = new Intl.Collator('fr', { sensitivity: 'base', numeric: true });

export const normalizeSearchableValue = (value = '') =>
  String(value ?? '')
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .toLowerCase()
    .trim();

export const getSearchTokens = (value = '') =>
  normalizeSearchableValue(value).split(SEARCH_TOKEN_SPLIT_REGEX).filter(Boolean);

export const matchesSearchTokens = (normalizedValue = '', includeTokens = [], excludeTokens = []) => {
  if (includeTokens.length > 0 && includeTokens.some((token) => !normalizedValue.includes(token))) {
    return false;
  }

  if (excludeTokens.length > 0 && excludeTokens.some((token) => normalizedValue.includes(token))) {
    return false;
  }

  return true;
};

export const compareRowsByFields = (rowA, rowB, sortFields = []) => {
  for (const field of sortFields) {
    const comparison = SEARCH_COLLATOR.compare(String(rowA?.[field] ?? ''), String(rowB?.[field] ?? ''));
    if (comparison !== 0) {
      return comparison;
    }
  }
  return 0;
};

export const filterSortRowsByAction = ({
  rows = [],
  actionId,
  actionField = 'IdentifiantAction',
  searchField,
  includeTokens = [],
  excludeTokens = [],
  sortFields = [],
}) => {
  if (!Array.isArray(rows) || rows.length === 0 || !actionId) {
    return [];
  }

  const filteredRows = [];
  for (const row of rows) {
    if (row?.[actionField] !== actionId) {
      continue;
    }

    const normalizedValue = searchField ? normalizeSearchableValue(row?.[searchField]) : '';
    if (searchField && !matchesSearchTokens(normalizedValue, includeTokens, excludeTokens)) {
      continue;
    }

    filteredRows.push(row);
  }

  if (sortFields.length > 0) {
    filteredRows.sort((rowA, rowB) => compareRowsByFields(rowA, rowB, sortFields));
  }

  return filteredRows;
};
